import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IDaylightMediaProps } from "./DaylightMedia.props";

const ratios = {
  "1:1": "aspect-square",
  "4:3": "aspect-4/3",
  "3:2": "aspect-3/2",
  "16:9": "aspect-video",
  "21:9": "aspect-21/9",
  "3:4": "aspect-3/4",
  "2:3": "aspect-2/3",
} as const;

export const DaylightMedia = ({
  aspectRatio,
  className,
  imageClassName,
  media,
  priority,
  sizes,
}: IDaylightMediaProps) => {
  const Image = getComponent("Image");
  return (
    <figure
      className={cn(
        "relative overflow-hidden border border-border bg-panel",
        aspectRatio && ratios[aspectRatio],
        className,
      )}
    >
      <Image
        alt={media.alternateText}
        className="h-full w-full"
        decoding="async"
        fetchPriority={priority ? "high" : undefined}
        height={media.height || undefined}
        imageClassName={cn(
          "h-full w-full",
          aspectRatio ? "object-cover" : "object-contain",
          imageClassName,
        )}
        loading={priority ? "eager" : "lazy"}
        priority={priority}
        sizes={sizes || media.sizes || undefined}
        src={media.defaultSrc}
        srcSet={media.srcSet || undefined}
        width={media.width || undefined}
      />
      {media.caption ? (
        <figcaption
          className={cn(
            "daylight-label-micro text-graphite/80",
            aspectRatio
              ? "absolute bottom-4 left-4 bg-terminal/60 px-3 py-2 backdrop-blur-sm"
              : "mt-3 text-northsea",
          )}
        >
          {media.caption}
        </figcaption>
      ) : null}
    </figure>
  );
};

DaylightMedia.displayName = "Content::DaylightMedia";
